import DarkButton from "components/actions/DarkButton";
import GrayButton from "components/actions/GrayButton";
import Dialog from "components/dialog";
import React from "react";

const DeleteStaff = ({ isOpen, onClose, personName = "this staff member" }) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} placement="top">
      <div className="text-lg font-bold dark:text-white mt-4">
        Disconnect Staff Member
      </div>

      <p className="text-sm text-gray-700 mt-4">
        Are you sure you want to delete <strong>{personName}</strong>?
      </p>

      <div className="flex flex-row gap-4 mt-6">
        <DarkButton kind="danger" onClick={onClose}>
          Delete
        </DarkButton>
        <GrayButton onClick={onClose}>Cancel</GrayButton>
      </div>
    </Dialog>
  );
};

export default DeleteStaff;
